import React from 'react';
export function Footer() {
  return <footer className="bg-navy border-t border-white/10 py-8" data-id="element-31">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-32">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-33">
          <p className="text-white/40 text-sm font-sans" data-id="element-34">
            © {new Date().getFullYear()} Protocolo Deuda Cero. Todos los
            derechos reservados.
          </p>
          <div className="flex items-center gap-6" data-id="element-35">
            <a href="#" className="text-white/50 hover:text-emerald-400 text-sm font-sans transition-colors duration-200" data-id="element-36">
              Política de Privacidad
            </a>
            <span className="text-white/20" data-id="element-37">|</span>
            <a href="#" className="text-white/50 hover:text-emerald-400 text-sm font-sans transition-colors duration-200" data-id="element-38">
              Términos y Condiciones
            </a>
          </div>
        </div>
      </div>
    </footer>;
}